import { useMemo, useState } from 'react'
import { useMemberComms } from 'hooks/useMemberComms'
import { useSidekick } from 'hooks/useSidekick'

/**
 * Custom hook that manages positioning of multiple poptarts to prevent overlap
 * when both are open simultaneously on desktop.
 *
 * @returns {Object} Object containing positioning classes and state information
 */
export const usePoptartPositioning = () => {
  const { isOpen: memberCommsOpen } = useMemberComms()
  const { isOpen: sidekickOpen } = useSidekick()

  // Track which poptart is on top (default to memberComms)
  const [topPoptart, setTopPoptart] = useState('memberComms')

  const positioning = useMemo(() => {
    const bothOpen = memberCommsOpen && sidekickOpen

    const handleToggle = poptartName => {
      // Only allow toggling when both poptarts are open
      if (bothOpen) {
        setTopPoptart(poptartName)
      }
    }

    return {
      // increase the z-index of the "top" poptart
      memberCommsClassName:
        topPoptart === 'memberComms' ? 'max-xs:z-20' : 'max-xs:z-10',
      sidekickClassName:
        topPoptart === 'sidekick' ? 'max-xs:z-20' : 'max-xs:z-10',
      bothOpen,
      memberCommsOpen,
      sidekickOpen,
      toggleTopPoptart: handleToggle,
    }
  }, [memberCommsOpen, sidekickOpen, topPoptart])

  return positioning
}
